import React from 'react';
import style from "./index.module.css";
import {Breadcrumb, Button, Divider} from "antd";
import CertificateNavModule from "../../components/certificateNavModule";
import {Table} from "antd";
import {DownloadOutlined} from '@ant-design/icons';
import {fileBaseUrl} from "../../utils";

const SeventhPage = () => {
    const baseItem = [
        {
            title: <div>首页</div>,
        },
        {
            title: "下载中心",
        },
    ];

    const columns: any[] = [
        {
            title: '文件名称',
            dataIndex: 'name',
            key: 'name',
            width: '70%',
        },
        {
            title: '操作',
            dataIndex: 'url',
            key: 'url',
            width: '30%',
            render: (url: string) => (<Button type={'link'} icon={<DownloadOutlined/>} onClick={() => {
                const link = document.createElement('a');
                link.href = url;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link); //下载完成移除元素
                window.URL.revokeObjectURL(url); //释放掉blob对象
            }}>
                点击下载
            </Button>),
        },
    ];

    const fileBaseURL = fileBaseUrl();

    const data = [
        // {
        //     id: 1,
        //     name: "12 认证证书样式",
        //     url: fileBaseURL + "certificationSample.pdf"
        // },
        {
            id: 2,
            name: "LSC14-1产品认证合同书",
            url: fileBaseURL + "LSC14-1-contract.doc"
        },
        // {
        //     id: 3,
        //     name: "LSC14-2认证申请书",
        //     url: fileBaseURL + "LSC14-2-apply.doc"
        // },
        // {
        //     id: 4,
        //     name: "CCAI-S-C02:2024 产品碳足迹认证实施规则 动力电池",
        //     url: fileBaseURL + "CCAI_S_C02.pdf"
        // },
        // {
        //     id: 5,
        //     name: "CCAI-S-C03:2024 产品碳足迹认证实施规则 锂电池电芯",
        //     url: fileBaseURL + "CCAI_S_C03.pdf"
        // },
        // {
        //     id: 6,
        //     name: "承诺书(扫描件)",
        //     url: fileBaseURL + "commitment.pdf"
        // },
        // {
        //     id: 7,
        //     name: "LSC-R-C01:2025 产品碳足迹认证实施规则 动力电池",
        //     url: fileBaseURL + "2-LSC-R-C01.pdf"
        // },
        // {
        //     id: 8,
        //     name: "LSC-R-C02：2025产品碳足迹认证实施规则  锂离子电池",
        //     url: fileBaseURL + "2-LSC-R-C02.pdf"
        // },
        // {
        //     id: 9,
        //     name: "LSC-G-SC-01公正性声明",
        //     url: fileBaseURL + "LSC-G-SC-01.pdf"
        // },
        {
            id: 10,
            name: "LSC16-1产品认证申请书",
            url: fileBaseURL + "LSC16-1.pdf"
        },
        {
            id: 11,
            name: "申诉、投诉和争议须知",
            url: fileBaseURL + "appeals.pdf"
        },
    ]

    return (
        <div className={style.pageContainer}>
            <Breadcrumb
                items={baseItem}
            />

            <div className={style.content}>
                <div className={style.leftNavBar}>
                    <CertificateNavModule/>
                </div>

                <div className={style.rightMainContainer}>
                    <div>
                        <div className={style.pageTitle}>下载中心</div>
                        <Divider style={{padding: '0 30px', borderColor: '#043554'}}>DOWNLOAD</Divider>
                    </div>


                    <div style={{width: "90%", margin: "10px 5%"}}>
                        <Table style={{
                            backgroundColor: '#eeeeee',  // 设置表格背景颜色
                            color: '#333',                // 设置字体颜色
                        }} size="small" showHeader={false} rowClassName={style.row} columns={columns}
                               dataSource={data}/>
                    </div>

                </div>
            </div>

        </div>

    );
};

export default SeventhPage;